import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link, usePage } from '@inertiajs/react'
import Button from '../../components/Button'

export default function TeamsIndex({ teams }) {
  const { auth } = usePage().props

  return (
    <AuthenticatedLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Lag</h1>
          {auth.user?.org_admin && (
            <Link href="/teams/new">
              <Button>Nytt lag</Button>
            </Link>
          )}
        </div>

        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
          {teams.length === 0 && (
            <p className="px-4 py-12 text-center text-gray-500 text-sm">Inga lag ännu.</p>
          )}
          {teams.map(t => (
            <Link
              key={t.id}
              href={`/teams/${t.id}`}
              className="flex items-center justify-between px-4 py-4 hover:bg-gray-50"
            >
              <p className="font-medium text-gray-900">{t.name}</p>
              <p className="text-sm text-gray-500">{t.members_count} medlemmar</p>
            </Link>
          ))}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
